import { render } from "./TransitionScreen.vue?vue&type=template&id=e357c4fe"
import script from "./TransitionScreen.vue?vue&type=script&lang=js"
export * from "./TransitionScreen.vue?vue&type=script&lang=js"

import "./TransitionScreen.vue?vue&type=style&index=0&id=e357c4fe&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__